var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"footer",attrs:{"app":""}},[_c('span',[_vm._v(_vm._s(new Date().getFullYear())+" — "),_c('strong',[_vm._v(" APTCODER")])]),_c('span',{staticClass:"ma-1",staticStyle:{"color":"black"}},[_vm._v(" (v.5.3)")])])
}
var staticRenderFns = []

export { render, staticRenderFns }